import { memo } from 'react';
// Local files
import Item from './Item/Item';
import BaseAnalysesList from 'components/Analyses/Common/BaseAnalysesList/BaseAnalysesList';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import useCustomSelector from 'hooks/useCustomSelector';
import useSixthAnalyses from 'hooks/useSixthAnalyses';
import { sixthAnalysesSelectors } from "features/sixthAnalyses";

const SixthAnalysesList = () => {
  const { getSixthAnalyses } = useSixthAnalyses();
  const { data, pagination } = useCustomSelector(sixthAnalysesSelectors.getSixthAnalysesData);
  const fetching = useCustomSelector(sixthAnalysesSelectors.sixthAnalysesIsFetching);

  return (
    <BaseAnalysesList
      fetchData={getSixthAnalyses}
      getData={data}
      isFetching={fetching}
      pagination={pagination}
      renderItem={(item) => <Item key={item.id} {...item} />}
    />
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <SixthAnalysesList {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);